<template>
    <div>
        <div v-for="childCM in HMData" :key="'value_' + childCM._id" :class="parentCM?'child-field-wrapper':''" style="">
            <template v-if="parentCM">  
                <li :id="'field-'+childCM._id" class="d-block li-style-change" :key="'value_' + childCM._id" style="width:98%">
                    <div style="display: flex;position:relative">
                              <div class="upload-fields" :class="{focusField:activeField == childCM.name, 
                              readonlyDiv: uploadScreenInfo.read_only_field_id_list.includes(childCM._id)}" v-on:click="activeField = childCM.name">
                                <div style="display: flex;">
                                  <div class="key-style">{{ getCustomMetadataName(childCM) }}
                                    <span class="readonly-field" v-if="uploadScreenInfo.read_only_field_id_list.includes(childCM._id)">
                                    ( non editable )
                                    </span>
                                  </div>
                                  <span style="color:#858585" v-if="uploadScreenInfo.mandatory_field_id_list.includes(childCM._id)">*</span>
                                </div>
                                <div class="value-style d-inline-flex">
                                  <div v-if="uploadScreenInfo.read_only_field_id_list.includes(childCM._id)"></div>
                                  <div v-else class="w-100">
                                    <input
                                      :value="getCustomMetadataById(childCM._id)"
                                      type="text"
                                      :class="{readOnly:nonEditableFields}"
                                      @change="updateCustomMetadataById(childCM, $event.target.value)"
                                      v-if="childCM.type == 'FREETEXT'"
                                      class="rounded input-fields text-light w-100"
                                      style="margin-inline-start:5px;padding: 4px;"
                                      :id="childCM._id"
                                      :placeholder="'Select '+childCM.name"
                                    />

                                    <textarea
                                      :value="getCustomMetadataById(childCM._id)"
                                      type="text"
                                      :class="{readOnly:nonEditableFields}"
                                      @change="updateCustomMetadataById(childCM, $event.target.value)"
                                      v-if="childCM.type == 'FREETEXT_MULTILINE'"
                                      class="rounded text-light w-100"
                                      style="margin-inline-start:5px;max-height:200px;min-height: 100px;padding: 4px;
                                      :1px solid #3a3a3a !important;"
                                      :id="childCM._id"
                                      :placeholder="'Select '+childCM.name"
                                      >
                                    </textarea>
                                    <input
                                      :value="getCustomMetadataById(childCM._id)"
                                      type="number"
                                      :class="{readOnly:nonEditableFields}"
                                      @change="updateCustomMetadataById(childCM, $event.target.value)"
                                      v-if="childCM.type == 'INTEGER'"
                                      class="rounded input-fields text-light w-100"
                                      style="margin-inline-start:5px;padding: 4px;"
                                      :id="childCM._id"
                                      :placeholder="'Select '+childCM.name"
                                    />
                                    <date-picker
                                      :value="getCustomMetadataById(childCM._id)"
                                      v-if="childCM.type == 'DATE'"
                                      valueType="format"
                                      :class="{readOnly:nonEditableFields}"
                                      @change="updateCustomMetadataById(childCM, $event)"
                                      class="rounded text-light w-100"
                                      style="margin-inline-start:5px;"
                                      :id="childCM._id"
                                      :placeholder="'Select '+childCM.name"
                                    >
                                    </date-picker>
                                    <date-picker
                                      :value="getCustomMetadataById(childCM._id)"
                                      v-if="childCM.type == 'DATE_TIME'"
                                      valueType="format"
                                      type="datetime"
                                      :class="{readOnly:nonEditableFields}"
                                      @change="updateCustomMetadataById(childCM, $event)"
                                      class="rounded text-light w-100"
                                      style="margin-inline-start:5px;"
                                      :id="childCM._id"
                                      :placeholder="'Select '+childCM.name"
                                      confirm
                                    >
                                    </date-picker>
                                    <Multiselect
                                      v-if="childCM.type == 'PICKLIST' && singlePicklistTypeCheck(childCM)"
                                      :value="getSinglePicklistVal(childCM._id)"
                                      :options="childCM.values"
                                      :searchable="true"
                                      :preserveSearch="true"
                                      :close-on-select="true"
                                      :id="childCM._id"
                                      :ref="childCM._id"
                                      :allow-empty="false"
                                      deselectLabel=""
                                      selectLabel=""
                                      selectedLabel=""
                                      track-by="value_id"
                                      label="value"
                                      @select="updateCustomMetadataById(childCM,$event)"
                                      placeholder="Select picklist"
                                      style="margin-inline-start:5px;">
                                      <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                                      <span style="margin-inline-start:12px;">{{ scope.option.value}}</span>
                                      </div>
                                      <span slot="noResult">No results.</span>
                                    </Multiselect>
                                    <Multiselect
                                        v-if="childCM.type == 'PICKLIST_MULTIVALUE' && picklistTypeCheck(childCM)"
                                        v-model="picklistData[childCM._id]"
                                        :options="childCM.values"
                                        :multiple="true"
                                        :id="childCM._id"
                                        @input="updateCustomMetadataById(childCM,$event)"
                                        @remove="removeSelectedPicklistOption($event,childCM)"
                                        :class="{readOnly:nonEditableFields}"
                                        placeholder="Select Picklist"
                                        :close-on-select="true"
                                        :show-no-results="true"
                                        :allow-empty="false"
                                        track-by="value_id"
                                        label="value"
                                        deselectLabel=""
                                        selectLabel=""
                                        selectedLabel=""
                                        style="margin-inline-start:5px !important;">
                                        <span slot="noResult">No results</span>
                                        <span slot="noOptions" style="display:none"></span>
                                        <div slot="tag" slot-scope="option" class="selected-tags-style">
                                        <div class="tags-display-style">{{option.option.value}}</div>
                                            <div class="remove-tag" v-on:click="removeSelectedPicklistOption(option.option,childCM)">
                                                <svg width="2em" height="1.5em" viewBox="0 0 16 16" class="bi bi-x" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                                                </svg>
                                            </div>
                                        </div>
                                        <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                                        <input type="checkbox" class="rounded text-light mr-3 bigger-checkboxes" :checked="makePicklistCheckBoxSelection(scope.option,childCM._id)" @focus.prevent :key="scope.option.name"/>
                                        <span style="margin-inline-start:12px;">{{ scope.option.value }}</span>
                                        </div></Multiselect>
                                  </div>
                                </div>
                                </div>
                              <div class="aboutField" :title="childCM.about_field" v-if="Object.keys(childCM).includes('about_field') &&
                                childCM.about_field.length" @click="enableOrDisableFieldInfo(childCM._id)">
                                <svg xmlns="http://www.w3.org/2000/svg" style="position: relative;inset-inline-start:2px;bottom: 2px;" width="16" height="16" fill="#939393" class="bi bi-question-circle-fill" viewBox="0 0 16 16">
                                  <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.496 6.033h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286a.237.237 0 0 0 .241.247zm2.325 6.443c.61 0 1.029-.394 1.029-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94 0 .533.425.927 1.01.927z"/>
                                </svg>
                              </div>
                    </div>
                </li>
                
                <template v-if="childCM.children && childCM.children.length">
                    <SequenceRecursiveList :parentCM="childCM" :HMData="childCM.children" :onGoingChanges="assetCustomMetadata" :defaultCategory="defaultCategory" :parentData="parentData" :ismediaEdit="ismediaEdit" :enableOnlyFields="enableOnlyFields" 
                            :screenType="screenType" :enableMediaSlug="enableMediaSlug" :assetsBrowseAccess="assetsBrowseAccess" @updatedCM="handleCMUpdate" />
                </template>
            </template>  
            <template v-else-if="childCM.children && childCM.children.length">
                <SequenceRecursiveList :parentCM="childCM" :HMData="childCM.children" :onGoingChanges="assetCustomMetadata" :defaultCategory="defaultCategory" :parentData="parentData" :ismediaEdit="ismediaEdit" :enableOnlyFields="enableOnlyFields" 
                            :screenType="screenType" :enableMediaSlug="enableMediaSlug" :assetsBrowseAccess="assetsBrowseAccess" @updatedCM="handleCMUpdate"  />
            </template>
        </div>
    </div>
</template>
  
<script>
    import highlightMixin from '../../mixins/SequenceMetadataComponentMixin.js';
    import "vue2-datepicker/index.css";
    import DatePicker from "vue2-datepicker";
    import Multiselect from 'vue-multiselect';

    export default {
        mixins:[highlightMixin],
        name: 'SequenceRecursiveList',
        props: {
            HMData: {
                type: Array,
                required: true
            },
            parentCM: {
                type: Object,
                default() {
                    return null;
                }
            },
            defaultCategory: {
                type: Object,
                default() {
                    return null;
                }
            },
            parentData: {
                type: Object,
                default() {
                    return null;
                }
            },
            onGoingChanges:{
                type:Array,
                default() {
                    return null;
                }
            },
            ismediaEdit: {
                type: Boolean,
                default() {
                    return false;
                }
            },
            enableOnlyFields: {
                type: Boolean,
                default() {
                    return false;
                }
            },
            enableMediaSlug: {
                type: Boolean,
                default() {
                    return false;
                }
            },
            screenType: {
                type: String,
                default() {
                    return false;
                }
            },
            assetsBrowseAccess: {
                type: Array,
                default() {
                    return false;
                }
            }
        },
        components:{
            "date-picker":DatePicker,
            Multiselect
        }
    };
</script>
  
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped lang="scss">
    $border-color: 1px solid #4a4a4a;
    $border-color-only:#4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $input-field-height:38px;
    $none-text-color:#4f4f4f;
    $input-field-padding:.375rem 10px;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555;
    $tags-background-color:#282d31;
    $tags-border-color:#363636;
    $metadata-border-color-on-hover: #5a5a5a;
    $secondary-border-color: 1px solid #2b2b2b;
    $readOnly-bg-color: #1e2326 !important;
    $add-button-text-color:#0b7099;
    $add-button-text-color-hover:#0193cc;
    $add-button-border-color:#b7b228;
    $add-button-border-on-hover:#dcd426;
    $add-button-backgroud:#1e1e1e;
    $highlight-font-color:#ff9800;

.child-field-wrapper{
    background: #22272b;
    border-inline-start: 3px solid #f59d00cf;
    padding: 7px 0px 7px 2px;
    border-radius: 0px 0px 4px 4px;
    margin: 0px 0px 4px 9px;
    position: relative;
    width: calc(100% - 8px);
    padding-bottom: 1px;
}

.actions-on-subclips{
    position: absolute;
    inset-inline-end: 0px;
    border: $border-color;
    width: auto;
    height: 35px;
    border-radius: 4px;
    top: 4px;
    inset-inline-end: 3px;
    padding: 0px 5px;
    background: $bg-color-on-hover;
    display:inline-flex;
    svg{
        margin:2px;
        background: #d1d2d31a;
        padding: 4px;
        height: 28px;
        width: 28px;
        border-radius: 4px;
        margin-inline-end: 5px;
        color: #c0c0c0;
    }
    svg:hover{
        background: #fdfeff54;
    }
}
.actions-on-subclips{
    visibility: hidden;
}


.li-style-change{
  border: 1px solid $metadata-border-color-on-hover !important;
}

.metadata-dock-ul li .aboutField {
  visibility: hidden;
}

.metadata-dock-ul li:hover .aboutField {
  visibility: visible;
}

.readonlyDiv{
    background: $readOnly-bg-color;
    border: none !important;
}

.readonly-field{
  color:$dull-text-color;
  font-size:12px;
}

.modal-dialog {
    width: 100vw;
    height: 100vh;
    max-width:100%;
    margin: 0;
    padding: 0;
  }

.selected-tags-style{
  background: $bg-color-on-hover;
  border: 1px solid $tags-border-color;
  border-radius: 15px;
  font-size: 12px !important;
  min-height: 30px !important;
  display: inline-flex !important;
  margin: 2px !important;
  border-radius: 15px !important;
  min-width: 50px !important;
  padding: 0px !important;
  text-align: center;
  width: auto !important;
  padding-inline-start: 12px !important;
  justify-content: center;
  padding-top: 4px !important;
  padding-inline-end: 4px !important;
  .remove-tag{
    line-height:18px;
  }
}

.tags-display-ul{
  margin-inline-start:0px;
    list-style-type: none;
    display: inline-flex;
    flex-wrap: wrap;
    margin-top: 0;
    width: 100%;
    justify-content: start;
    overflow: auto;
  label{
    padding: 0px 5px;
  }
}
  
  .modal-content {
    height: auto;
    min-height: 100%;
    border: 0 none;
    border-radius: 0;
    box-shadow: none;
    background:$primary-background !important;
    border: $border-color;
    .modal-body{
      background: $primary-background;
      overflow:auto;
      height:300px;
      padding: 0px 0px 0px 0px;
      display:inline-flex;
      width:100%;
    }
  }

.modal {
  text-align: center;
  padding: 0!important;
  display:block;
}
.modal:before {
  content: '';
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  margin-inline-end: -4px;
}
.modal-dialog {
  display: inline-block;
  text-align: start;
  vertical-align: middle;
}

.btn{
    font-size:14px !important;
    height:100%;
}

    ::-webkit-scrollbar {
     width: 8px;
    }

    ::-webkit-scrollbar-track {
      background: $scrollbar-track-background;
    }

    ::-webkit-scrollbar-thumb {
      background: $scrollbar-thumb-background;
    }

    ::-webkit-scrollbar-thumb:hover {
      background: $scrollbar-thumb-on-hover-background;
    }

.border{
    border: $border-color !important;
}

.activeclass{
    color: $active-blue;
}
.activeNav,.activeNav:hover{
    color: $active-blue !important;
    border: 1px solid $metadata-border-color-on-hover;
}
.row{
  margin:-12px !important;
  margin-inline-start:0px !important;
}

.metadata-fields{
  background: $primary-background;
  border-inline-start: $secondary-border-color !important;
}

.modal-header,.modal-footer{
    border: none !important;
    background: $secondary-background-color;
    align-items: unset;
    .modal-title{
      color:$text-color;
      padding:3px;
    }
}
.upload-fields{
    width: 100%;
    border-radius: 5px;
}

.modal-header .close {
    // margin: -1rem -19px -0rem auto !important;
    margin:0px !important;
    padding: 0px !important;
}

ul{
    list-style-type: none;
}

.primary-btn-style{
    margin-top:1%;
    display:inline-flex !important;
    flex-wrap: nowrap !important;
    button{
        border-radius: 5px;
        width: 70px;
        font-size:14px;
        float:inline-end;
    }
}


.secondary-btn-style{
  color:$text-color;
}

.modal-footer{
    justify-content: start;
}

.view-tags {
    font-size: 12px !important;
    min-height: 28px !important;
    display: inline-flex !important;
    margin: 2px !important;
    border: 1px solid $tags-border-color !important;
    border-radius: 15px !important;
    min-width: 50px !important;
    padding: 0px 5px !important;
    text-align: center;
    width: auto !important;
    justify-content: center;
    padding-top: 4px !important;
    background: $tags-background-color !important;
  span, div {
    padding: 0px 8px !important;
    margin-inline-start: 0px !important;
    font-size: 12px !important;
    border-radius: 15px !important;
    position: relative !important;
    top: 1px !important;
  }
}

span{
  white-space: pre-wrap;
}

.view-tags:hover {
  border: $border-color !important;
}

.activeTag{
    color: $active-blue !important;
}

.align-texts{
  li{
    .value-style{
      padding-inline-start: 5px !important;
    }
  }
}

.metadata-dock-ul {
  list-style-type: none;
  padding: 0px;
  user-select: none; 
  position:relative;
  margin-inline-start:0px;
  width:100%;
  background:$primary-background;
  overflow:auto;
  .fields-styles{
      margin-bottom:8px;
    li{
      margin-bottom:1px;
    }
  }
  li {
    display: inline-block;
    width: 100%;
    padding: 7px;
    border: $border-color;
    border-radius: 4px;
    margin: 4px 8px;
    width: 96%;
    position: relative;
    background:$primary-background;
    .key-style {
      color: $dull-text-color;
      width: auto;
      text-align: start;
      font-size: 14px;
      padding-inline-start: 5px;
      padding-inline-end: 5px;
      margin-top: 3px;
    }
    .value-style {
      color: $text-color;
      width: 97%;
      text-align: start;
      padding-top: 3px;
      padding-bottom: 3px;
      padding-inline-end: 5px;
      padding-inline-start: 0px;
      user-select: text !important; 
      cursor:text;
      .slug-ellipsis {
        max-width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-all;
      }
      .save-cancel-icon{
        position:relative;
        top:10px;
        inset-inline-start:5px;
        color:#fff;
      }
      .browse-icon{
        color:#636363 !important;
      }
    }
  }
  li:hover{
    border:1px solid $metadata-border-color-on-hover
  }
}

.display-subclips{
  width:100% !important;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.display-subclips:hover{
  .actions-on-subclips{
    visibility: visible;
  }
}

.metadata-dock-ul li .editIcon {
  opacity: 0;
}

.metadata-dock-ul li:hover .editIcon,.metadata-dock-ul li:focus-within .editIcon {
  opacity:1;
}
.editIcon {
  margin-inline-start: 9px;
  position: absolute;
    inset-inline-end: 2%;
    top: 10px;
}

.aboutField{
  margin-inline-start: 9px;
  position: absolute;
    inset-inline-end: 1%;
    top: 45%;
}
.input-fields {
  min-width: 250Px;
  padding-inline-start:5px;
  padding-top: 2px;
  height:38px;
  outline: none;
  --saf-0: rgba(var(--sk_highlight,18,100,163),1);
  // box-shadow: 0 0 0 1px var(--saf-0),0 0 0 5px #00254E;
  border-radius: 4px;
  border: 1px solid #4a4a4a !important;
  -webkit-appearance: none;
}

.text-light{
  color: #f8f9fa !important;
}

.tags-display-ul .show-tags-delete{
  visibility:hidden;
}

.tags-display-ul li:hover .show-tags-delete{
  visibility: visible;
}

.show-tags-delete{
  position: relative;
  top: 2px;
}

::v-deep{
.theme--light.v-text-field--solo>.v-input__control>.v-input__slot {
        background: $primary-background;
        border-bottom: $border-color;
    }
.theme--light.v-text-field--filled:not(.v-input--is-focused):not(.v-input--has-state)>.v-input__control>.v-input__slot:hover {
    background:$primary-background;
}
.theme--light.v-chip {
    border-color:#3a3a3a !important;
    color:$text-color;
}

.theme--light.v-chip:not(.v-chip--active) {
    background: $primary-background;
}

.v-list-item--link:before{
  background-color:$primary-background;
}
.vjs_video_3-dimensions, .video-js{
    height:350px;
    width:100% !important;
}
.video-js{
    height:350px;
    width:100% !important;
}
.mx-input{
    background-color:$primary-background !important;
    border: none !important;
    color: #eee !important;
}
.mx-datepicker-main{
    border: 1px solid #2f2f2f !important;
    background: $primary-background !important;
}
.mx-calendar-content .cell:hover{
    background-color: $bg-color-on-hover !important;
}
.mx-datepicker-range{
  width:100%
}
.mx-datepicker{
  padding:0px !important;
}
.mx-calendar-content .cell:hover {
    color: #000000;
    background-color: #7d99b1;
}
.mx-icon-calendar{
  color: $dull-text-color ;
}
.mx-icon-clear{
  color: $dull-text-color;
}
}
.secondary-btn-style:hover{
  text-decoration: underline;
}

.assets-details-in-metadata-manager{
    height:calc(100% - 348px);
    overflow:auto;
    padding:0px 15px;
}

.metadata-dock-ul{
    height:100%;
    display:inline-block;
    padding-bottom: 10px;
}

.metadata-dock-ul li:focus {
  border: 1px solid $active-blue !important;
}
ul{
    list-style-type: none;
    padding: 0px;
    margin-inline-start:10px;
    li{
        display:inline-flex;
        width: 100%;
        padding:7px;
        .key-style{
            color:$dull-text-color;
            width:30%;
            text-align: start;
        }
        .value-style{
            color: #b6b6b6;
            width: 70%;
            text-align: start;
            user-select: text !important; 
            cursor:text;
        }
    }
}

.selected-thumbnail-display{
    width: 100%;
    display: inline-block;
    max-width: 50%;
    img{
        height:100%;
        width:100%;
    }
    svg{
        float: inline-end;
        margin-top:5px;
    }
}


::v-deep{
  .multiselect {
    margin: 3px 0px;
  }

  .multiselect_tags{
    min-height: 40px !important;
    height: 40px !important;
    padding: 8px 40px 0 8px  !important;
    border-radius: 5px !important;
  }
  .multiselect__content-wrapper {
    display: none;
  }
  .multiselect__tag, .tags-style {
    background-color: $primary-background !important;
    border: $border-color;
    border-radius: 5px;
  }
  .multiselect__tags, .tags-style {
    background: transparent !important;
    border: $border-color !important;
  }
  .multiselect__option--highlight {
    background: $bg-color-on-hover !important;
  }
  .multiselect__content {
    background: $secondary-background-color !important;
  }
  .multiselect__input,
  .multiselect__single {
    background: transparent !important;
    color: $text-color;
    word-break: break-all;
  }
  .multiselect__single{
    padding-inline-start: 9px !important;
    margin-top: 0px !important;
    padding-top: 6px !important;
  }
  .multiselect__input{
      padding-top:0px !important;
  }

  .multiselect__tag-icon {
    color: $text-color !important;
  }
  .multiselect__tag-icon:focus,
  .multiselect__tag-icon:hover {
    background: $bg-color-on-hover !important;
    color: $text-color !important;
  }
  .multiselect__tag-icon:after {
    color: $secondary-text-color !important;
    font-size: 23px;
  }

  .multiselect__tag-icon {
    visibility: hidden;
  }

  .multiselect__tag:hover .multiselect__tag-icon {
    visibility: visible;
  }
  .multiselect__tags:focus, .multiselect__input:focus{
    outline: none;
    height: 38px;
    bottom: 0px;
    inset-inline-start:0px;
    --saf-0: rgba(var(--sk_highlight,18,100,163),1);
    box-shadow: 0 0 0 1px var(--saf-0),0 0 0 5px #00254E;
    border-radius: 4px;
    border-color: transparent;
    -webkit-appearance: none;
    }

  .multiselect * {
    font-size: $input-field-and-label-font-size;
    font-family: "Roboto", Arial, sans-serif !important;
  }
  .multiselect__placeholder {
    padding-top: 8px !important;
    padding-inline-start:8px;
  }
  .multiselect {
    color: $text-color !important;
    font-size: $input-field-and-label-font-size !important;
    width: 100%;
    min-height: 38px !important;
    height:auto !important;
  }
  .multiselect__option--selected {
    background: $bg-color-on-hover !important;
    color: $text-color;
  }
  .multiselect__content-wrapper {
    border: 1px solid $bg-color-on-hover !important;
    position: absolute !important;
    display: block;
    background: $text-color;
    width: 100% !important;
    max-height: 180px !important;
    overflow: auto;
    border: 1px solid $text-color;
    border-top: none;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    z-index: 50;
    -webkit-overflow-scrolling: touch;
  }

  .multiselect__current,
  .multiselect__option {
    line-height: 12px !important;
  }

  .multiselect--above .multiselect__content-wrapper {
    background: $secondary-background-color !important;
  }
  .multiselect__tags {
    padding: 4px 0px 5px 0px; 
  }
  .multiselect__tags-wrap{
    max-height:150px !important;
    display: inline-block;
    overflow: auto;
  }
   .multiselect__tags-wrap::-webkit-scrollbar {
     width: 8px;
    }

    .multiselect__tags-wrap::-webkit-scrollbar-track {
      background: $scrollbar-track-background;
    }

    .multiselect__tags-wrap::-webkit-scrollbar-thumb {
      background: $scrollbar-thumb-background;
    }

    .multiselect__tags-wrap::-webkit-scrollbar-thumb:hover {
      background: $scrollbar-thumb-on-hover-background;
    }

    .multiselect__content-wrapper::-webkit-scrollbar {
     width: 8px;
    }

    .multiselect__content-wrapper::-webkit-scrollbar-track {
      background: #22272b !important;
    }

    .multiselect__content-wrapper::-webkit-scrollbar-thumb {
      background: $scrollbar-thumb-background !important;
    }

    .multiselect__content-wrapper::-webkit-scrollbar-thumb:hover {
      background: $scrollbar-thumb-on-hover-background;
    }

    font[color~=OrangeRed] {
      color: $highlight-font-color !important;
    }
}

.audio-player{
    position: absolute;
    bottom: 0px;
    width: 100%;
    height: 26px;
    inset-inline-start:0px;
}

.close-icon:hover{
  background: #373737;
  border-radius: 20px;
}

input:focus,select:focus,textarea:focus,.multiselect__input:focus,.mx-input:focus{
    outline: none;
    --saf-0: rgba(var(--sk_highlight,18,100,163),1);
    box-shadow: 0 0 0 1px var(--saf-0),0 0 0 5px #00254E;
    border-radius: 4px;
    border-color: transparent;
    -webkit-appearance: none;
}
.label-tree-style{
  font-size: 12px !important;
  color:$dull-text-color;
  margin-top:4px;
  word-break: break-all;
  white-space: pre-wrap;
  margin-inline-start:12px;
}

.all-users-selection:hover{
  background: $bg-color-on-hover;
}

.bigger-checkboxes {
    height: 30px;
    width: 20px;
    position:relative;
}


input[type="checkbox"]:after {
    line-height: 1.5em;
    content: "";
    display: inline-block !important;
    width: 22px !important;
    height: 21px !important;
    margin-top: 5px !important;
    margin-inline-start: -1px !important;
    border: $border-color !important;
    border-radius: 0.25em !important;
    background: $primary-background !important;
}
input[type="checkbox"]:checked:after {
    content: "✔";
    color: $active-blue !important;
    position: absolute !important;
    font-size: 16px !important;
    line-height: 1 !important;
    transition: all 0.2s !important;
    font-family: Helvetica, Arial, sans-serif;
    padding-inline-start: 4px !important;
    padding-top: 2px !important;
}

.user-name-or-image{
    height: 30px;
    width: 30px;
    border: $border-color;
    border-radius: 10px;
    text-align: center;
    line-height: 28px;
    text-transform: uppercase;
    margin-top: 3px;
    margin-inline-end: 5px;
}

.browse-icon{
    position: relative;
    inset-inline-start:8px;
    top: 3px;
}

.table td, .table th {
    border-top: none;
    padding:0px;
}

.display-as-tags{
    display: inline-flex;
    flex-wrap: wrap;
    justify-content: start;
    float: inline-start;
}

.select-catalog-field{
    width: 101%;
    .value-style{
      width:100%;
    }
}

.user-name-or-image {
  height: 30px;
  width: 30px;
  border: $border-color;
  border-radius: 10px;
  text-align: center;
  line-height: 28px;
  text-transform: uppercase;
  margin-top: 3px;
  margin-inline-start: 5px;
}

.user-name-or-image-in-selected-option{
  border: $border-color;
  height: 26px;
  width: 26px;
  border-radius: 5px;
  text-align: center;
  line-height: 26px;
  text-transform: uppercase;
  margin-top: -1px;
  margin-inline-start: -1px;
  }

.tags-style{
    display: inline-flex;
    margin-inline-end: 5px;
    margin-bottom: 2px;
    height: 27px;
    margin-inline-start: 3px;
  .user-name-display-as-tags{
      line-height: 27px;
      margin-inline-start: 6px;
  }
}

.remove-tag{
  color:$dull-text-color;
  line-height: 25px;
}

.remove-tag:hover{
  color:$text-color;
}

textarea{
  height:150px !important;
  resize: none;
  overflow: auto;
}
.edit-icon-style{
  visibility: hidden;
  position: absolute;
  top:4px;
  inset-inline-end:5px;
  display:inline-flex;
  svg{
      margin-inline-end:5px;
  }
}

.subclips-section:hover{
  .edit-icon-style{
    position: absolute;
    top:4px;
    inset-inline-end:5px;
    display:inline-flex;
    svg{
      margin-inline-end:5px;
    }
  }
}
.subclips-section{
  background:transparent !important;
  padding:0px !important;
  border:none !important;
  margin-inline-end:0px !important;
  ul{
    margin-inline-start:0px;
    .display-subclips{
      margin:4px 0px !important;
    }
  }
}

.active-subclip-preview{
  border: 2px solid $active-blue !important;
}

.no-data-found{
  color: $secondary-text-color;
  text-align: center;
  margin-bottom:10px;
}

 .icon-background-on-hover:hover{
    background: #d1d2d31a;
    }

.icon-background-on-hover{
    padding: 6px;
    height: 28px;
    width: 28px;
    border-radius: 4px;
    }

.add-subclips-styles{
    display: inline-flex;
    height: 57px;
    border: 1px solid $add-button-border-color;
    border-radius: 10px;
    width: 97%;
    justify-content: center;
    line-height: 52px;
    color:$add-button-text-color;
}

.add-subclips-styles:hover{
    border: 1px solid $add-button-border-on-hover;
    color:$add-button-text-color-hover;
}

.transcript-wrapper{
  li{
    border: none !important;
    border-bottom: 1px solid #242424 !important;
    border-radius: 0 !important;
  }
  li:last-child{
    border-bottom: 0 !important;
  }
  .transcript-preview {
       :hover .transcript-play-pause{
          // visibility: visible;
          svg{
            fill:#eee !important;
          }
       }
      .transcript-content{
        display: flex;
        align-items: flex-start;
        text-align: start;
      }
      .transcript-play.transcript-timestamp{
        display: flex;
        align-items: center;
      }
      .transcript-spoken-content{
          margin-inline-start: 6px;
          text-align: start;
          user-select: text;
          cursor: auto;
      }
      .transcript-play-pause{
        //  visibility: hidden;
        svg{
          fill:#5e5e5e !important;
        }
      }

      .common-media-in-out-display{
          font-size: 14px;
          background: rgb(52, 52, 52);
          padding: 4px 5px; 
          justify-content: start; 
          display: flex; 
          border-radius: 3px;
          color: rgb(238, 238, 238) !important;
          gap:3px;
      }
  }
}

.config-desc{
  color: $dull-text-color;
  font-size: 15px;
  margin-top: 1px;
}

.custom-switch .custom-control-label::before{
  background: transparent;
}
.custom-control-input:checked~.custom-control-label:before {
  color: #fff;
  border-color: #007bff;
  background-color: #007bff !important;
}

.custom-control-label::before {
  background-color: $primary-background;
}
</style>

  